import { Box } from '@hivebrite/design-system/Box';
import { toast } from '@hivebrite/design-system/Toast';

import TerminationForm from 'hb-react/frontoffice/apps/Mentoring/components/TerminationForm';
import { useUpdateRelationshipRequest } from 'hb-react/frontoffice/apps/Mentoring/hooks/useMutateRelationship';
import { type Program } from 'hb-react/frontoffice/apps/Mentoring/types';
import ModalWithTemplate from 'hb-react/shared/components/DesignSystem/Modal/ModalWithTemplate';

interface EndRelationshipModalProps {
  onCloseModal: () => void;
  program: Program;
  relationshipId: number;
}

const EndRelationshipModal = ({
  onCloseModal,
  program,
  relationshipId,
}: EndRelationshipModalProps) => {
  const { mutateAsync } = useUpdateRelationshipRequest({
    program,
    relationshipId,
    onSuccess: onCloseModal,
  });

  const onSubmit = async ({ message }: { message: string }) => {
    try {
      await mutateAsync({
        ended_relationship_message: message,
        status: 'terminated',
      });
      toast.success(__('Successfully sent'));
      // eslint-disable-next-line no-empty
    } catch {}
  };

  return (
    <ModalWithTemplate
      onCloseModal={onCloseModal}
      header={s__('Mentoring|End mentoring relationship')}
    >
      <Box width="100%">
        <TerminationForm
          validations={{ required: true, maxLength: 1000 }}
          label={s__('Mentoring|End relationship')}
          placeholder={s__(
            'Mentoring|Please provide a note as to why you are ending the relationship. Typical messages include: saying thank you, what you learned, and highlighting strengths or areas to improve in the future. Thank you.',
          )}
          onCloseModal={onCloseModal}
          onSubmit={onSubmit}
        />
      </Box>
    </ModalWithTemplate>
  );
};

export default EndRelationshipModal;
